import React from "react";
import { COMPANY_FIELDS } from "@/lib/printTemplates";
import { useConfigEditor, EditorBar, Field, Panel } from "./common";

export default function CompanyTab() {
  const ed = useConfigEditor("company");
  if (!ed.value) return null;
  const set = (k, v) => ed.set((s) => ({ ...s, [k]: v }));
  return (
    <div data-testid="company-tab">
      <EditorBar ed={ed} testid="company"><p className="text-sm text-muted-foreground">Тези данни се печатат във фактурите. Полетата със * са задължителни, за да издадете фактура.</p></EditorBar>
      <Panel>
        <div className="grid sm:grid-cols-2 gap-3">
          {COMPANY_FIELDS.map(([k, l]) => <Field key={k} label={l} value={ed.value[k]} onChange={(v) => set(k, v)} testid={`company-${k}`} />)}
          <Field label="ДДС % за нощувки" type="number" value={ed.value.rooms_vat_rate ?? 9} onChange={(v) => set("rooms_vat_rate", v)} testid="company-rooms-vat" />
        </div>
      </Panel>
    </div>
  );
}
